module.exports = __webpack_public_path__ + "img/no-data.7f385084.png";